import { AbstractControl } from "@angular/forms";
import { CommonMessages } from "./common.message";
import { CommonValidators } from "./common.validator";

export function emailValidator(control: AbstractControl) {
  if (control.dirty) {
    if (control.value == null)
      return { TextError: CommonMessages.NonEmptyField };
    else {
      if (!CommonValidators.ValidateEmail(control.value))
        return { TextError: CommonMessages.InvalidEmail };
    }
  }

  return null;
}

export function minimoTresCaracteresValidator(control: AbstractControl) {
  if (control.dirty) {
    if((control.value as string).length < 3) {
        return { TextError: CommonMessages.MinimoTresCaracteres }
    }
  }

  return null;
}

export function minimoCaracteresTelefoneValidator(control: AbstractControl) {
  if (control.dirty && control.value) {
    if((control.value as string).length < 10){
      return { TextError: CommonMessages.MinimoCaracteresTelefone }
    }
  }

  return null;
}

export function minimoDigitosCodigoAutenticidade(control: AbstractControl) {
  if (control.dirty && control.value) {
    if((control.value.length > 0 && (control.value.length < 18 || !CommonValidators.isNumericOnly(control.value)))){
      return { TextError: CommonMessages.LimiteMinimoCodigoAutenticidade }
    }
  }

  return null;
}
